export default class PageTransitionExtension {

    phase = 0;
    animationClasses = {
        initClass: 'animate__animated',
        outClass: 'animate__fadeOutLeft',
        loadingClass: 'is-loading',
        inClass: 'animate__fadeInRight',
    }


    constructor(selector, animationClasses) {
        this.selector = selector;
        if (animationClasses) {
            if (animationClasses.hasOwnProperty('initClass'))
                this.animationClasses.initClass = animationClasses.initClass

            if (animationClasses.hasOwnProperty('outClass'))
                this.animationClasses.outClass = animationClasses.outClass;

            if (animationClasses.hasOwnProperty('loadingClass'))
                this.animationClasses.loadingClass = animationClasses.loadingClass;

            if (animationClasses.hasOwnProperty('inClass'))
                this.animationClasses.inClass = animationClasses.inClass;
        }
    }

    initialize(naja) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.defaultPageTransition = document.querySelector(this.selector);
            });

        } else {
            this.defaultPageTransition = document.querySelector(this.selector);
        }
        naja.uiHandler.addEventListener('interaction', this.pageTransitionSelector.bind(this));

        // naja.snippetHandler.addEventListener('beforeUpdate', this.eventStart.bind(this));
        // naja.snippetHandler.addEventListener('afterUpdate', this.eventSuccess.bind(this));

        naja.addEventListener('start', this.eventStart.bind(this));
        naja.addEventListener('complete', this.eventSuccess.bind(this));
    }

    pageTransitionSelector(event) {
        const pageTransition = event.detail.element.closest('[data-page-trasition]');
        event.detail.options.pageTransition = pageTransition || this.defaultPageTransition;
    }

    eventStart(event) {
      //  console.log('before');
      //  console.log(event.detail);

        if (event.detail.request.method === 'GET') {
            // if (event.detail.snippet.id === 'snippet--content') {
            const element = document.querySelector(this.selector); //event.detail.options.pageTransition;
            // console.log(element);
            this.animationStart(element);
            element.addEventListener('animationend', (event) => {
                switch (this.phase) {
                    case 1:
                        this.animationMiddle(element);
                        break;
                    case 2:
                        this.animationComplete(element)
                        this.phase = 0;
                        break;
                }
            }, {once: true});
        }
    }

    eventSuccess(event) {
        //if (event.detail.snippet.id === 'snippet--content') {
        if (event.detail.request.method === 'GET') {
            this.phase = 2;
            const element = event.detail.options.pageTransition;
            this.animationEnd(element)
        }
    }

    animationStart(element) {
        // console.log('start');
        this.phase = 1;
        element?.classList.add(this.animationClasses.initClass);
        element?.classList.add(this.animationClasses.outClass);
        // console.log(element);
    }

    animationMiddle(element) { // this part works only with slow connection
        element?.classList.remove(this.animationClasses.outClass);
        while (element.firstChild) {
            element.firstChild.remove()
        } // remove all child html elements
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        element?.classList.add(this.animationClasses.loadingClass);
        // console.log('middle');
    }

    animationEnd(element) {
        document.body.scrollTop = 0;// When middle part isn't run
        document.documentElement.scrollTop = 0;// When middle part isn't run
        element?.classList.remove(this.animationClasses.outClass); // When middle part isn't run
        element?.classList.remove(this.animationClasses.loadingClass);
        element?.classList.add(this.animationClasses.inClass);
        // console.log('end');
    }

    animationComplete(element) {
        element?.classList.remove(this.animationClasses.initClass);
        element?.classList.remove(this.animationClasses.inClass);
        // console.log('end-2');
    }
}